import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {TravelsHandlerService} from '../../../../api-handlers/travels-handler.service';
import {AuthService} from '../../../../auth-n-routing/auth-service.service';

@Component({
	selector: 'app-tra-paginator',
	templateUrl: './tra-paginator.component.html',
	styleUrls: ['./tra-paginator.component.css']
})
export class TraPaginatorComponent implements OnInit {
	@Output() reloadRequested = new EventEmitter();
	dom_elements = {
		max_size: 3
	};

	constructor(public travelsHandlerService: TravelsHandlerService, public authService: AuthService) {
		if (window.screen.width < 470) {
			this.dom_elements.max_size = 2;
		}
	}
	
	ngOnInit() { }
	
	pageChanged(event) {
		this.travelsHandlerService.travels_list_props.current_page = event.page;
		this.travelsHandlerService.travels_list_props.item_per_page = event.itemsPerPage;
		this.reloadRequested.next(undefined);
	}
	
	refreshCurrentPage() {
		if (!this.travelsHandlerService.travels_list_props.item_per_page) {
			this.travelsHandlerService.travels_list_props.item_per_page = 1;
		}
		this.reloadRequested.next(undefined);
	}
	
	itemPerPageChanged(new_number: number) {
		this.travelsHandlerService.travels_list_props.current_page = 1;
		this.travelsHandlerService.travels_list_props.item_per_page = new_number;
		console.log(this.travelsHandlerService.travels_list_props.count);
		this.reloadRequested.next(undefined);
	}
	
	restore() {
		this.travelsHandlerService.restoreBodyTravelsFilters();
		this.reloadRequested.next(undefined);
	}

}
